export enum RMCEventType {
	OPEN = 'OPEN_RESOURCE_MEDIA_CONTROL_COMPONENT',
	CLOSE = 'CLOSE_RESOURCE_MEDIA_CONTROL_COMPONENT'
}